import {
	Component, Input, OnInit, OnChanges, SimpleChanges, SimpleChange,
	ChangeDetectionStrategy, ChangeDetectorRef
} from '@angular/core';
import { DeviceLink, DeviceLinkMember } from '../../dtos/topology/DeviceLink';
import { MonitorState } from '../../dtos/topology/DeviceConnection';

@Component({
	selector: 'link-details',
	templateUrl: './linkdetails.component.html',
	styleUrls: ['./linkdetails.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkDetailsComponent {

	@Input()
	public selectedLinks: DeviceLink[];
	public get hasSelectedLinks(): boolean {
		return (this.selectedLinks && this.selectedLinks.length > 0);
	}

	@Input()
	public version: number;

	public cols: any[];
	public linkMembers: DeviceLinkMember[];

	public display: boolean;
	public show(): void {
		this.display = true;

		this.changeDetector.markForCheck();
	}
	public hide(): void {
		this.display = false;

		this.changeDetector.markForCheck();
	}

	constructor(private changeDetector: ChangeDetectorRef) {
		this.selectedLinks = [];
		this.version = 0;
		this.cols = [];
		this.linkMembers = [];
		this.display = false;
	}

	public ngOnInit(): void {

	}

	public ngOnChanges(changes: SimpleChanges): void {
		let change: SimpleChange = null;

		change = changes["selectedLinks"];
		if (change) {
			if (this.hasSelectedLinks) {
				this.cols = this.getCols();

				let distinctLinks = new Set<DeviceLink>();
				this.selectedLinks.forEach(link => distinctLinks.add(link));

				this.linkMembers = [];
				distinctLinks.forEach((link: DeviceLink) => {
					this.linkMembers.push(...link.linkMembers);
				}, this);
			}
			else {
				this.cols = [];
				this.linkMembers = [];
			}
		}
	}

	protected getCols(): any[] {
		let result = [
			{ field: 'deviceName', header: 'Device', stateField: 'monitorState' },
			{ field: 'ifIndex', header: 'IF Index', stateField: 'monitorState' },
			{ field: 'ifName', header: 'IF Name', stateField: 'monitorState' },
		];

		if (!this.selectedLinks.every(link => link.allWirelessOrVm)) {
			result.push({ field: 'connectedDevice', header: 'Conn Device', stateField: 'connectedMonitorState' });
			result.push({ field: 'connectedIfIndex', header: 'Conn IF Index', stateField: 'connectedMonitorState' });
			result.push({ field: 'connectedIfName', header: 'Conn IF Name', stateField: 'connectedMonitorState' });
		}

		if (!this.selectedLinks.every(link => link.noWireless)) {
			result.push({ field: 'radio', header: 'Radio', stateField: '' });
			result.push({ field: 'ssid', header: 'SSID', stateField: '' });
		}

		if (!this.selectedLinks.every(link => link.noVm)) {
			result.push({ field: 'virtualPort', header: 'Virt Port', stateField: '' });
			result.push({ field: 'virtualPortGroup', header: 'Virt Port Group', stateField: '' });
		}

		result.push({ field: 'linkType', header: 'Link Type', stateField: '' });

		return result;
	}

	public getMonStateStyle(monState: MonitorState): string {
		switch (monState) {
			case undefined:
			case MonitorState.NoData:
				return 'nonestate';
			case MonitorState.Up:
				return 'upstate';
			case MonitorState.Warning:
				return 'warningstate';
			case MonitorState.Down:
				return 'downstate';
			default:
				return 'otherstate';
		}
	}

}
